module.exports = __webpack_public_path__ + "img/bg-1.9b001b54.jpg";